<template>
  <q-layout view="lHh Lpr lFf">
    <q-header elevated>
      <q-toolbar>
        <q-toolbar-title>
          M-Serial
        </q-toolbar-title>
        <q-chip>
          <q-icon flat round dense name="cloud" size="sm" :color="mqtt_running ? 'green' : 'red'" />
          <q-icon flat round dense name="usb" size="sm" :color="serial_running ? 'green' : 'red'" />
        </q-chip>

        <q-btn v-if=mqtt_running round dense :color="mqtt_status_color" :icon="service_icon" size="20px"
          :disable="service_timeout" @click="service_stop" />
        <q-btn v-else round dense :icon="service_icon" size="20px" :disable="service_timeout" @click="service_start" />
      </q-toolbar>
    </q-header>

    <q-page-container>
      <GeneralConfigurations />
      <MessagesHistory />
    </q-page-container>
  </q-layout>
</template>

<script>
import { ref } from 'vue'
import { connect } from "mqtt"
import { Notify } from 'quasar'

import GeneralConfigurations from './components/GeneralConfigurations.vue'
import MessagesHistory from './components/MessagesHistory.vue'

var client,
  port,
  textEncoder,
  textDecoder,
  reader,
  writer,
  readableStreamClosed;

export default {
  name: 'LayoutDefault',

  components: {
    GeneralConfigurations,
    MessagesHistory,
  },

  data() {
    return {
      service_icon: "play_circle",
      service_timeout: false,
      mqtt_running: false,
      mqtt_status_color: "green",
      serial_running: false,
    }
  },

  setup() {
    return {
      leftDrawerOpen: ref(false)
    }
  },

  methods: {
    async service_start() {
      this.service_timeout = true;
      new Promise(() => {
        setTimeout(() => { this.service_timeout = false; }, 1000)
      })
      let mqtt = this.$store.getters.getMQTTConfig;
      mqtt.options.keepalive = 10;
      if (typeof client == 'undefined' || (client.connected == false && client.disconnected == true)) {

        client = connect(mqtt.host, mqtt.options)
        client.on("connect", function () {
          console.log("MQTT connected");
          this.service_icon = "pause_circle";
          this.mqtt_running = true;
          this.mqtt_status_color = "green";
        }.bind(this))
        client.on("disconnect", function () {
          console.log("MQTT disconnect");
          this.service_icon = "play_circle";
          this.mqtt_running = false;
        }.bind(this))
        client.on("end", function () {
          console.log("MQTT end");
          this.service_icon = "play_circle";
          this.mqtt_running = false;
        }.bind(this))
        client.on("reconnect", function () {
          console.log("MQTT reconnect");
          this.mqtt_status_color = "red";
          this.mqtt_running = false;
        }.bind(this))
        client.on('message', function (topic, message) {
          console.log(topic, " message is: " + message);
          this.checkForAlert(message.toString());
          var content = {};
          content.topic = topic;
          content.data = message.toString();
          content.ts = new Date();
          this.$store.commit('pushMessage', content);
        }.bind(this));

        var topic_list = [mqtt.topic];
        client.subscribe(topic_list, { qos: 1 });

        var options = {
          retain: true,
          qos: 0
        };
        client.publish(mqtt.topic, "web client [m-serial] started", options);
      }

      if (this.$store.state.serial.enable) {
        await this.getSerialPorts();
        if (this.$store.state.serial.enable_decoder && this.serial_running && port != undefined && 'readable' in port) {
          this.readSerial(this.$store.state.serial.enable_decoder);
        } else {
          this.readSerial(this.$store.state.serial.enable_decoder);
        }
      }
    },
    async service_stop() {
      this.service_timeout = true;
      if (this.serial_running) {
        this.serial_running = false;
        try {
          reader.cancel();
          await readableStreamClosed.catch(() => { /* Ignore the error */ });
          await port.close();

        } catch {/* Ignore the error */ }
      }
      client.end();
      new Promise(() => {
        setTimeout(() => { this.service_timeout = false; }, 1000)
      })
    },
    checkForAlert(message) {
      var alarms = this.$store.state.alarms;
      alarms.forEach(alarm => {
        if (message.includes(alarm.keyword)) {
          Notify.create({
            message: 'Alarm rule was triggered',
            color: 'info',
          })
          if (this.$store.state.serial.enable && alarm.type == "Serial") {
            this.writeSerial(alarm.command);
          } else if (alarm.type == "Browser notification") {
            if (window.Notification && Notification.permission !== "denied") {
              Notification.requestPermission(function () {  // status is "granted", if accepted by user
                new Notification('Title', {
                  body: 'Alarm rule was triggered by this word: ' + alarm.keyword,
                  icon: 'caution.png'
                });
              });
            }
          }
        }
      });
    },
    async getSerialPorts() {
      try {
        port = await navigator.serial.requestPort();
        await port.open({ baudRate: this.$store.state.serial.baudrate });
        this.serial_running = true;
      } catch (err) {
        console.log("Error found in Serial: ", err);
        this.serial_running = false;
      }

    },
    writeSerial(text) {
      try {
        console.log("command sent:", text)

        textEncoder = new TextEncoder();
        // writableStreamClosed = textEncoder.readable.pipeTo(port.writable);
        writer = port.writable.getWriter();
        writer.write(textEncoder.encode(text));
        writer.releaseLock();
        this.serial_running = true;
      } catch {
        this.serial_running = false;
        Notify.create({
          message: 'Serial Error',
          color: 'red',
        })
      }

    },
    async readSerial(decoder) {
      while (port.readable && this.serial_running) {

        textDecoder = new window.TextDecoderStream()
        readableStreamClosed = port.readable.pipeTo(textDecoder.writable)
        reader = textDecoder.readable.getReader()
        var clear_buffer = true;

        try {
          while (this.serial_running) {
            const { value, done } = await reader.read()
            if (done) {
              break
            }
            if (value && !clear_buffer) {
              clear_buffer = false;
              var message = value.toString();
              const regex = /.*(?:\r\n|\n|\r)(?=\r\n|\n|\r|$)/g;
              let match;
              while ((match = regex.exec(message)) !== null) {
                console.log(decoder)
                if (decoder) {
                  const decoder_string = match[0].replace(/(?:\r\n|\r|\n)/g, '');
                  var wrap = () => "{ return " + this.$store.state.serial.decoder + " };"
                  var func = new Function(wrap());
                  let result = func.call(null).call(null, decoder_string);
                  if (result != null && result != "") {
                    client.publish(result.topic, result.message);
                  }
                } else {
                  client.publish(this.$store.state.mqtt.topic, message);
                }

              }
            }
            clear_buffer = false;
          }
        } catch (error) {
          console.error(error)
        } finally {
          reader.releaseLock();
        }
      }
    },
  },
}


</script>
